import { render, staticRenderFns } from "./SalesforceIcon.vue?vue&type=template&id=3a8c172a&"
import script from "./SalesforceIcon.vue?vue&type=script&lang=ts&"
export * from "./SalesforceIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports